import { render, staticRenderFns } from "./TypeManagementTable.vue?vue&type=template&id=2621ff9a"
import script from "./TypeManagementTable.vue?vue&type=script&lang=js"
export * from "./TypeManagementTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports